import { httpClient } from './httpClient';

export interface ApiKey {
  id: string;
  name: string;
  description: string | null;
  scopes: string[] | null;
  last_used_at: string | null;
  expires_at: string | null;
  created_at: string;
  revoked_at: string | null;
}

export interface CreateApiKeyPayload {
  name: string;
  description?: string;
  scopes?: string[];
  expiresAt?: string;
}

export interface CreateApiKeyResponse {
  success: boolean;
  apiKey: string;
  keyId: string;
}

export const apiKeyService = {
  createApiKey: async (payload: CreateApiKeyPayload): Promise<CreateApiKeyResponse> => {
    return httpClient.post<CreateApiKeyResponse>('/api/api-keys', payload);
  },

  getTenantApiKeys: async (skip = 0, limit = 50): Promise<ApiKey[]> => {
    const result = await httpClient.get<{ success: boolean; apiKeys: ApiKey[] }>(
      `/api/api-keys/tenant?skip=${skip}&limit=${limit}`
    );
    return result.apiKeys;
  },

  revokeApiKey: async (keyId: string): Promise<void> => {
    await httpClient.delete(`/api/api-keys/${keyId}`);
  }
};
